import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { Link} from "react-router-dom"
import './return.css'
import {authenticationFn} from '../../redux/chatuser.redux.js'
import {authenMsg} from '../../redux/chatuser.redux.js'
import {userList} from '../../redux/chatuser.redux.js'


import HeaderPC from '../../component/headerPC/headerPC.js'
import AuthenticatePC from '../../component/authenticate-pc/authenticate.js'
import OpenGames from '../../component/open-games/openGames.js'


@connect(
  state=>state.chatuser,
  {userList,authenticationFn,authenMsg}
)

class ReturnPC extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            gameList: null,
            detailVal: '',
            authenticationData: ''
        }
        this.handleVla = this.handleVla.bind(this)
        this.authenticationDataFn = this.authenticationDataFn.bind(this)
        this.handleLink = this.handleLink.bind(this)
    }
    componentDidMount() {
        document.title = '心享俱乐部—回归特权';
        this.getAllGames()
    }
    
  	handleLink(item){
  		 		
        this.props.history.push('/return-detail-pc/'+item.game_id)
        this.props.authenMsg(this.state.detailVla)

    }
    getAllGames(){
        axios.get('/fapi/recom/getAllGames?page=0&limit=0')
            .then(res=>{
                
                if(res.data.return_code===0){
                    
                    if(this.state.authenticationData.game_often){

                        for(let i=0;i<this.state.authenticationData.game_often.length;i++){
                            for(let j=0;j<res.data.data.length;j++){

                                if(this.state.authenticationData.game_often[i].game_id==res.data.data[j].game_id){
                                    
                                    var idata = res.data.data
                                    idata[j].onOff = true
                                    this.setState({
                                      gameList:idata
                                    })
                                }
                             }
                        }
                    }else{
                        this.setState({
                            gameList:res.data.data
                        })
                    }
                }
            })
    }
    
  	handleVla(data){
        this.setState({
            detailVla:data
        })
    }
    authenticationDataFn(data){
  		
        this.setState({
            authenticationData:data
        },function () {
            this.getAllGames()
        })
    }
    render(){
        return(
            <div className="return-pc-box">
                <HeaderPC></HeaderPC>
                <AuthenticatePC
                    handleVla={this.handleVla} 
                    authenticationDataFn={this.authenticationDataFn}
                ></AuthenticatePC>
                <OpenGames 
                    gameList={this.state.gameList}
                    handleLink={this.handleLink}
                ></OpenGames>
            </div>
        )
    }
}
export default ReturnPC;


// WEBPACK FOOTER //
// ./src/container/return-pc/return.js